import React from "react";
import "./styles/Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <div className="loader-square">
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
